import { render, staticRenderFns } from "./FormProcessDesign.vue?vue&type=template&id=6a812cd9&scoped=true"
import script from "./FormProcessDesign.vue?vue&type=script&lang=js"
export * from "./FormProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./FormProcessDesign.vue?vue&type=style&index=0&id=6a812cd9&prod&lang=less"
import style1 from "./FormProcessDesign.vue?vue&type=style&index=1&id=6a812cd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a812cd9",
  null
  
)

export default component.exports